import styled from "styled-components";

export const TextContainer = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 10px;
`;
export const TextWrapper = styled.div<{ width?: string }>`
  width: ${(props) => (props.width ? props.width : "10%")};
  justifycontent: left;
  display: grid;
`;
